import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem("cookie_consent"));

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener("cookie-consent-reset", reopen);
    return () => window.removeEventListener("cookie-consent-reset", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem("cookie_consent", JSON.stringify({ value, at: new Date().toISOString() }));
    if (value === "declined") {
      localStorage.removeItem("ai_output_language");
      localStorage.removeItem("aish_tour_done");
    }
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-[#0B0F0D] border border-[#D4AF37]/40 rounded-2xl shadow-2xl p-4 sm:p-5 text-white">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-[#D4AF37]/15 flex items-center justify-center shrink-0">
            <Cookie size={18} className="text-[#D4AF37]" />
          </div>
          <div className="flex-1">
            <p className="text-sm font-semibold">Cookies on this site</p>
            <p className="text-xs text-gray-400 mt-1 leading-relaxed">
              We use essential cookies to keep you logged in, plus optional local storage for your preferences (like AI reply language).
              No advertising or tracking cookies. See our <Link to="/cookies" className="text-[#D4AF37] hover:underline">Cookie Policy</Link>.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <button data-testid="cookie-accept-btn" onClick={() => choose("accepted")}
                className="bg-gradient-to-r from-amber-500 to-yellow-500 text-slate-950 text-xs font-bold px-4 py-2 rounded-full hover:brightness-105 transition-all">
                Accept
              </button>
              <button data-testid="cookie-decline-btn" onClick={() => choose("declined")}
                className="bg-white/10 border border-white/20 text-gray-200 text-xs font-bold px-4 py-2 rounded-full hover:bg-white/15 transition-colors">
                Decline non-essential
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
